import script from "./CommissionRange.vue?vue&type=script&setup=true&lang=js"
export * from "./CommissionRange.vue?vue&type=script&setup=true&lang=js"

import "./CommissionRange.vue?vue&type=style&index=0&id=f8a7672e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8a7672e"]])

export default __exports__